import { LOCALE_LABELS as COMMON_LABELS } from "../../../../common/locale/labels";

export type LocaleLabels = typeof COMMON_LABELS;

export const LOCALE_LABELS: LocaleLabels = {
    ...COMMON_LABELS,
};
